import React, {useEffect, useState} from 'react';
import {makeRequest} from "../../utils/httpRequest";
import Config from "../../core/config";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import ConfirmButton from "../common/ConfirmButton";
import ActionButtonsManagerView from "../common/ActionButtonsManagerView";
import DecimalInput from "../common/DecimalInput";import {useNavigate} from "react-router-dom";
import Loading from "../../core/Loading";
import {UserPermission} from "../../utils/utils";
import {usePermission} from "../../core/PermissionContext";
import {getAllPaymentMethodsMercadoPago} from "../../utils/requestUtils";

const apiUrl = Config.apiUrl;
const PaymentMethodManager = (props) => {
    const { hasUserPermission, loadingPermissions } = usePermission();
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(window.location.search);
    const id = searchParams.get('id');

    const newEntity = {
        id: undefined,
        name: '',
        allowSplit: false,
        fee: 0.0,
        paymentMethodsMercadoPago: []

    };
    const [formData, setFormData] = useState(newEntity);
    const [paymentMethodsMercadoPago, setPaymentMethodsMercadoPago] = useState([]);

    const [loading, setLoading] = useRecoilState(loadingAtom);

    async function loadPaymentMethodsMercadoPago() {
        if (!hasUserPermission(UserPermission.ENABLE_MERCADO_PAGO)) {
            return;
        }
        try {
            const response = await getAllPaymentMethodsMercadoPago();
            setPaymentMethodsMercadoPago(response || []);
        } catch (error) {
            console.error('Error loading payment methods MercadoPago:', error);
        }
    }

    async function makeQuery() {
        if (id) {
            try {
                setLoading(true);
                const url = apiUrl + '/api/paymentMethods/id=' + id;
                const response = await makeRequest(url, 'GET');
                setFormData(response);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        } else {
            setFormData(newEntity);
        }

    }

    useEffect(() => {
        makeQuery();
        loadPaymentMethodsMercadoPago();
    }, [id]);

    function validate() {

        if (!formData.name || formData.name === '') {
            alert(`Informe o nome.`);
            return false;
        }

        return true;
    }

    const handlePaymentMethodMercadoPagoChange = (paymentMethodId, checked) => {
        setFormData((prevData) => {
            const currentPaymentMethods = prevData.paymentMethodsMercadoPago || [];
            let updatedPaymentMethods;
            
            if (checked) {
                // Add the payment method if it's not already in the list
                if (!currentPaymentMethods.includes(paymentMethodId)) {
                    updatedPaymentMethods = [...currentPaymentMethods, paymentMethodId];
                } else {
                    updatedPaymentMethods = currentPaymentMethods;
                }
            } else {
                // Remove the payment method from the list
                updatedPaymentMethods = currentPaymentMethods.filter(id => id !== paymentMethodId);
            }
            
            return {
                ...prevData,
                paymentMethodsMercadoPago: updatedPaymentMethods
            };
        });
    };

    const handleSelectAll = (checked) => {
        setFormData((prevData) => {
            if (checked) {
                // Select all payment methods
                const allPaymentMethodIds = paymentMethodsMercadoPago.map(pm => pm.id);
                return {
                    ...prevData,
                    paymentMethodsMercadoPago: allPaymentMethodIds
                };
            } else {
                // Unselect all payment methods
                return {
                    ...prevData,
                    paymentMethodsMercadoPago: []
                };
            }
        });
    };

    const isAllSelected = () => {
        if (!paymentMethodsMercadoPago.length) return false;
        const currentSelected = formData.paymentMethodsMercadoPago || [];
        return paymentMethodsMercadoPago.every(pm => currentSelected.includes(pm.id));
    };

    const isIndeterminate = () => {
        if (!paymentMethodsMercadoPago.length) return false;
        const currentSelected = formData.paymentMethodsMercadoPago || [];
        const selectedCount = currentSelected.length;
        return selectedCount > 0 && selectedCount < paymentMethodsMercadoPago.length;
    };

    const onConfirm = async () => {
        if (!validate()) {
            return;
        }
        try {
            const url = apiUrl + '/api/paymentMethods';
            setLoading(true);
            await makeRequest(url, id ? 'PUT' : 'POST', {
                'Content-Type': 'application/json',
            }, JSON.stringify(formData));
            setFormData(newEntity);
            navigate('/app/paymentmethodlist');
        } catch (error) {
            console.error('Error adding paymentMethod:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const {name, value, type, checked} = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    if (loadingPermissions) {
        return <Loading/>
    }

    if (hasUserPermission(UserPermission.CREATE_PAYMENT_METHOD) === false || (hasUserPermission(UserPermission.EDIT_PAYMENT_METHOD) === false && id)) {
        navigate('/unauthorizedaccess');
    }

    return (
        <div style={{width: '350px'}}>
            <div className="header-label">{id > 0 ? 'Editar' : 'Cadastrar'} Forma de Pagamento</div>

            {formData.id && (
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div style={{width: '180px'}}>Código:</div>
                    <input type="text" style={{backgroundColor: '#CCCCCC'}} value={formData.id} disabled={true}/>
                </div>)}

            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Nome:</div>
                <input type="text" value={formData.name}
                       name="name"
                       onChange={handleChange}/>
            </div>

            <div style={{marginTop: '5px', alignItems: 'center', display: 'flex'}}>
                <div>Permite parcelar?</div>
                <input type="checkbox" checked={formData.allowSplit}
                       name="allowSplit"
                       onChange={handleChange}/>
            </div>

            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Acréscimo/Taxa (%):</div>
                <DecimalInput
                    value={formData.fee}
                    name="fee"
                    min={0}
                    onChange={handleChange}
                    style={{width: '100px'}}/>
            </div>

            {hasUserPermission(UserPermission.ENABLE_MERCADO_PAGO) && (
                <div style={{marginTop: '15px'}}>
                    <div style={{marginBottom: '10px', fontWeight: 'bold'}}>Métodos de Pagamento MercadoPago:</div>
                    <div style={{marginBottom: '10px', display: 'flex', alignItems: 'center'}}>
                        <input
                            type="checkbox"
                            id="select-all-payment-methods"
                            checked={isAllSelected()}
                            ref={(input) => {
                                if (input) {
                                    input.indeterminate = isIndeterminate();
                                }
                            }}
                            onChange={(e) => handleSelectAll(e.target.checked)}
                            style={{marginRight: '8px'}}
                        />
                        <label htmlFor="select-all-payment-methods" style={{cursor: 'pointer', fontWeight: 'bold'}}>
                            Selecionar Todos
                        </label>
                    </div>
                    <div style={{maxHeight: '200px', overflowY: 'auto', border: '1px solid #ccc', padding: '10px'}}>
                        {paymentMethodsMercadoPago.map((paymentMethod) => (
                            <div key={paymentMethod.id} style={{marginBottom: '8px', display: 'flex', alignItems: 'center'}}>
                                <input
                                    type="checkbox"
                                    id={`paymentMethod-${paymentMethod.id}`}
                                    checked={formData.paymentMethodsMercadoPago && formData.paymentMethodsMercadoPago.includes(paymentMethod.id)}
                                    onChange={(e) => handlePaymentMethodMercadoPagoChange(paymentMethod.id, e.target.checked)}
                                    style={{marginRight: '8px'}}
                                />
                                <label htmlFor={`paymentMethod-${paymentMethod.id}`} style={{cursor: 'pointer'}}>
                                    {paymentMethod.name} ({paymentMethod.codeMercadoPago})
                                </label>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            <ActionButtonsManagerView>
                <ConfirmButton onClick={onConfirm}/>
            </ActionButtonsManagerView>
        </div>
    );
};

export default PaymentMethodManager;
